export default __webpack_public_path__ + "static/media/slider-3.e9057797.jpg";